import React, { useState } from 'react';
import './CalculatorPage.css';

function HouseNumberAnalysis() {
  const [houseNumber, setHouseNumber] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzeNumber = (number) => {
    // Placeholder for House Number Analysis logic
    if (!number) return null;
    const digits = number.replace(/\D/g, '');

    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
      sum += parseInt(digits[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    return `The numerological value of your house number is ${sum}. This is a placeholder explanation for house number analysis.`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!houseNumber) {
      setError('Please enter a house number.');
      return;
    }

    const calculated = analyzeNumber(houseNumber);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "House Number Analysis",
    "description": "Analyze your house number for numerological insights and its influence on your home life.",
    "url": "https://www.yourwebsite.com/house-number-analysis",
    "potentialAction": {
      "@type": "AnalyzeAction",
      "name": "Analyze House Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/house-number-analysis?number={houseNumber}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=houseNumber"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">House Number Analysis</h1>
      <p className="text-center">Enter your house number to get a numerological analysis.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="houseNumber">House Number:</label>
          <input
            type="text"
            id="houseNumber"
            className="form-control"
            value={houseNumber}
            onChange={(e) => setHouseNumber(e.target.value)}
            placeholder="e.g., 123, 12A"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Analysis:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default HouseNumberAnalysis;
